import React from 'react';

const ReserveImage = props => (
  <svg
    width="277"
    height="211"
    viewBox="0 0 277 211"
    xmlns="http://www.w3.org/2000/svg"
    className={props.className}
  >
    <g id="Page-1" fill="none" fillRule="evenodd">
      <g id="reserve" transform="translate(1 1)">
        <path
          d="M258.9,159.2 C258.9,149.9 266.4,142.4 275.7,142.4 L275.7,116.8 C275.7,113 272.6,109.9 268.8,109.9 L48.6,110 C44.8,110 41.7,113.1 41.7,116.9 L41.7,142.6 C42.2,142.6 42.6,142.5 43.1,142.5 C52.4,142.5 59.9,150 59.9,159.3 C59.9,168.6 52.4,176.1 43.1,176.1 C42.6,176.1 42.1,176.1 41.7,176 L41.7,201.7 C41.7,205.5 44.8,208.6 48.6,208.6 L268.7,208.5 C272.5,208.5 275.6,205.4 275.6,201.6 L275.6,176 C266.4,176 258.9,168.5 258.9,159.2 Z"
          id="Shape"
          fill="#65C9DB"
          fillRule="nonzero"
        />
        <path
          d="M230.3,57 C225.8,48.1 229.3,37.2 238.2,32.7 L225.6,8 C223.7,4.3 219.2,2.9 215.6,4.7 L4.4,112.5 C0.7,114.4 -0.7,118.9 1.1,122.5 L13.7,147.2 C14.1,146.9 14.6,146.7 15,146.4 C23.9,141.9 34.8,145.4 39.3,154.3 C43.8,163.2 40.3,174.1 31.4,178.6 C30.9,178.8 30.5,179 30,179.2 L42.6,203.8 C44.5,207.5 49,208.9 52.6,207.1 L263.8,99.4 C267.5,97.5 268.9,93 267.1,89.4 L254.6,64.8 C245.7,69.4 234.8,65.8 230.3,57 Z"
          id="Shape"
          fill="#5FC3B5"
          fillRule="nonzero"
        />
        <g
          id="Group"
          transform="translate(163 31)"
          stroke="#8B8A8A"
          strokeWidth="2.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        >
          <path d="M0.2,0.8 L1.8,4" id="Shape" />
          <path
            d="M5.3,10.8 L45.1,88.9"
            id="Shape"
            strokeDasharray="7.6251,7.6251"
          />
          <path d="M46.8,92.3 L48.5,95.5" id="Shape" />
        </g>
        <path
          d="M135.4,94.4 L130,93.8 L125.4,84.9 L119.4,88 L122,92.9 L108.5,91.5 C107.8,91.4 106.9,91.6 106.2,92 C105.5,92.4 104.8,92.9 104.5,93.6 L91.3,117.3 C90.6,118.6 90.6,120.8 91.3,122.1 L106,150.3 C106.7,151.6 108.4,152.2 109.7,151.5 L153,129 C154.3,128.3 154.8,126.6 154.1,125.3 L139.4,97.1 C138.7,95.8 136.9,94.5 135.4,94.4 Z"
          id="Shape"
          stroke="#636464"
          strokeWidth="2.5"
          fill="#FFF"
          fillRule="nonzero"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M126.5,107.7 L122.1,129.5 C122,129.8 121.9,130 121.7,130.2 L121.6,130.3 C121.3,130.4 121,130.5 120.8,130.3 L112,126.9 C111.6,126.7 111.3,126.3 111.4,125.9 C111.5,125.5 111.8,125.1 112.3,125 L118.3,124.2 L124.7,107.3 C124.9,106.8 125.4,106.5 125.9,106.7 C126.3,106.7 126.6,107.2 126.5,107.7 Z"
          id="Shape"
          fill="#5FC3B5"
          fillRule="nonzero"
        />
        <path
          d="M226.7,8.6 C224.8,4.9 220.3,3.5 216.7,5.3 L5.5,113.1 C1.8,115 0.4,119.5 2.2,123.1 L2.8,124.3 L227.3,9.8 L226.7,8.6 Z"
          id="Shape"
          fill="#CBE8E3"
          fillRule="nonzero"
        />
        <path
          d="M230.3,57 C225.8,48.1 229.3,37.2 238.2,32.7 L225.6,8 C223.7,4.3 219.2,2.9 215.6,4.7 L4.4,112.5 C0.7,114.4 -0.7,118.9 1.1,122.5 L13.7,147.2 C14.1,146.9 14.6,146.7 15,146.4 C23.9,141.9 34.8,145.4 39.3,154.3 C43.8,163.2 40.3,174.1 31.4,178.6 C30.9,178.8 30.5,179 30,179.2 L42.6,203.8 C44.5,207.5 49,208.9 52.6,207.1 L263.8,99.4 C267.5,97.5 268.9,93 267.1,89.4 L254.6,64.8 C245.7,69.4 234.8,65.8 230.3,57 Z"
          id="Shape"
          stroke="#636464"
          strokeWidth="2.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <g id="Group" transform="translate(138)" fillRule="nonzero">
          <circle
            id="Oval"
            stroke="#636464"
            strokeWidth="2.5"
            fill="#FFF"
            cx="29.8"
            cy="29.4"
            r="29"
          />
          <g id="Shape">
            <path
              d="M29.5,31.6 L28.2,31.6 C28,30.5 27.6,28.5 27.3,25.8 C27,22.2 21.2,18.5 17.7,17.2 C21.1,16 27,12.2 27.4,8.5 C27.6,5.9 28,4.2 28.2,2.7 L29.4,2.7 C30.2,2.7 30.9,2.2 30.9,1.5 C30.9,0.7 30.2,0.3 29.4,0.3 L2.1,0.3 C1.3,0.3 0.6,0.8 0.6,1.5 C0.6,2.3 1.3,2.7 2.1,2.7 L3.2,2.7 C3.4,4.1 3.9,5.8 4.4,8.5 C5,12.1 10.3,15.8 13.8,17.1 C10.3,18.3 4.9,22.1 4.3,25.7 C3.8,28.4 3.3,30.5 3.1,31.5 L2.1,31.5 C1.3,31.5 0.6,32.1 0.6,32.9 C0.6,33.7 1.3,34.3 2.1,34.3 L29.4,34.3 C30.2,34.3 30.9,33.7 30.9,32.9 C30.9,32.1 30.3,31.6 29.5,31.6 Z"
              fill="#4DBED8"
              transform="translate(14 12)"
            />
            <path
              d="M6.1,7.8 C5.7,5.6 5.3,3.8 5.1,2.8 L26.7,2.8 C26.5,3.9 26.2,5.6 26,7.8 C25.7,11.7 18.8,15.7 16.4,16 L16.7,13.6 C18.8,12.9 22.8,10.2 23,7.5 C23,7 23.1,6.6 23.1,6.3 C21.3,7.3 18.9,8.3 16.2,8.9 C13.8,9.5 11.5,9.7 9.6,9.7 C11.1,11.7 13.8,13.5 15.4,13.8 L15.7,16 C12.9,15.7 6.7,11.7 6.1,7.8 Z"
              stroke="#4DBED8"
              fill="#FFF"
              transform="translate(14 12)"
            />
            <path
              d="M5,31.6 C5.2,30.5 5.6,28.8 6,26.5 C6.6,22.7 12.8,18.7 15.5,18.3 L15.8,25.2 C14,25.4 9,28 8.5,29.8 L23.5,29.8 C23.2,28 18.3,25.5 16.4,25.2 L16.6,18.3 C19.2,18.9 25.6,22.7 26,26.5 C26.2,28.8 26.5,30.5 26.7,31.6 L5,31.6 Z"
              stroke="#4DBED8"
              fill="#FFF"
              transform="translate(14 12)"
            />
          </g>
        </g>
      </g>
    </g>
  </svg>
);

export default ReserveImage;
